const initialState = {
  sidebarShow: true,
  sidebarUnfoldable: false,
  title: '',
};

export default function app(state = initialState, { type, ...rest }) {
  switch (type) {
    case 'set':
      return { ...state, ...rest };
    default:
      return state;
  }
}
